import { render } from "./order-dialog.vue?vue&type=template&id=350de1dd&ts=true"
import script from "./order-dialog.vue?vue&type=script&lang=ts"
export * from "./order-dialog.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__